export default 'M14.89 1.93q.1.26.11.57v8a1.5 1.5 0 0 1-3 0V6.12L3.62 14.5a1.5 1.5 0 1 1-2.12-2.12L9.88 4H5.5a1.5 1.5 0 0 1 0-3h8a1.5 1.5 0 0 1 1.39.93';